import * as actions from "../constants/actionTypes";
export const INITIAL_STATE = {
    hostProfileData: {
        metadata: {
            countryCode: "",
            email: "",
            firstName: "",
            lastName: "",
            locationInfo: {
                state: "",
                city: "",
                country: "",
                countryName: "",
                countryFlag: ""
            },
            phone: "",
            profilePic: "",
        },
        status: "",
        contestName: "",
        contestCategory: "",
        aboutSelf: "",
        enrolledDate: "",
        lastMediaUploadDate: "",
        endorseUser:[],
    },
    hostProfileMedia: [],
    hasMore: true,
    hostProfileLoader: true,
}

export default (state = INITIAL_STATE, action) => {

    switch (action.type) {
        case actions.GET_HOST_PROFILE_DATA_SUCCESS:
            return {
                ...state,
                hostProfileData: action.payload.hostProfileData,
                hostProfileLoader: false,
                hostProfileMedia: action.payload.Media,
                hasMore: action.payload.Media.length >= 20
            }
        
        case actions.GET_HOST_PROFILE_MEDIA_SUCCESS:
                localStorage.setItem("loadMoreJudgesProfile", false);
            return {
                ...state,
                hostProfileMedia: [...state.hostProfileMedia,...action.payload],
                hasMore: action.payload.length >= 20
            }


        case actions.RESET_HOST_PROFILE_DATA:
            return {
                hostProfileData: {
                    metadata: {
                        countryCode: "",
                        email: "",
                        firstName: "",
                        lastName: "",
                        locationInfo: {
                            state: "",
                            city: "",
                            country: "",
                            countryName: "",
                            countryFlag: ""
                        },
                        phone: "",
                        profilePic: "",
                    },
                    status: "",
                    contestName: "",
                    contestCategory: "",
                    aboutSelf: "",
                    enrolledDate: "",
                    lastMediaUploadDate: "",
                    media: [],
                    endorseUser:[],
                },
                hostProfileMedia: [],
                hasMore: true,
                hostProfileLoader: true,
            }
        default:
            return state




    }





}